import styled from 'styled-components'

type TBannerBackgroundColor = {
  backgroundColor: string
}

export const BannerContainer = styled.div<TBannerBackgroundColor>`
  width: 100%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
`

export const BannerTitle = styled.span`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.headerText};
`
